<script lang="ts">
    import LayerListItem from "./LayerListItem.svelte";
    import type { LayerListItemGroupManager } from "./LayerListItemGroupManager";
    import { _ } from "svelte-i18n";

    export let manager: LayerListItemGroupManager;
    const modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    const layerListItemManagers = manager.getLayerListItemManagers();
    const expandedStore = manager.getExpandedStore();
    const groupKey = manager.getGroupKey();
    const oneGroup = manager.getOneGroup();

    const onToggle = () => {
        $expandedStore = !$expandedStore;
    };
</script>

{#if !oneGroup}
    <div
        class="list-group-item border-0 border-top p-4 py-3 bg-light"
        aria-current="true">
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{$_(`${$modelTranslationKeyStore}.layers.groups.${groupKey}`)}</h5>

            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="input-group-text border-0 p-0" on:click={onToggle}>
                {#if $expandedStore}
                    <i class="fe fe-chevron-up"></i>
                {:else}
                    <i class="fe fe-chevron-down"></i>
                {/if}
            </span>
        </div>
    </div>
{/if}

{#if $expandedStore}
    {#each layerListItemManagers as layerListItemManager}
        <LayerListItem manager={layerListItemManager} />
    {/each}
{/if}
